export class ApiError implements Error {
  name = 'ApiError';
  message: string;
  code: string | number = undefined;
  status: number = undefined;
  stack?: string;

  constructor(message: string, code?: string | number, status?: number) {
    this.message = message;

    if (code) {
      this.code = code;
    }

    if (status) {
      this.status = status
    }
  }

  public toString(): string {
    return this.message || this.code.toString();
  }
}
